// src/rem.js
function setRem() {
  const baseSize = 16; // 设计稿宽度390px的1/100
  const scale = document.documentElement.clientWidth / 390; // 以1440px宽度为基准进行缩放
  document.documentElement.style.fontSize = (scale * baseSize) + 'px';
}

setRem();
window.onresize = () => setRem(); // 窗口大小变化时重新设置
